document.addEventListener('DOMContentLoaded', () => {
    new Swiper('.js-reviews-swiper', {
        slidesPerView: 'auto',
        spaceBetween: 16,
        allowTouchMove: true,
        navigation: {
            prevEl: '.reviews-prev',
            nextEl: '.reviews-next',
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        breakpoints: {
            1024: {
                slidesPerView: 3,
                slidesPerGroup: 2,
                spaceBetween: 40,
                freeMode: {
                    enabled: true,
                },
            },
        },
    });
});
